import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CoreService } from '../../../../service/core.service';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.css']
})
export class VouchersComponent implements OnInit {
  @ViewChild('closeModal', { static: false }) closeModal: ElementRef;
  @ViewChild('btnReset', { static: false }) btnReset: ElementRef<HTMLElement>;
  up: any;
  impRes: any;
  base_url: string;
  constructor(private coreService: CoreService,private apiService: ApiService) { }

  ngOnInit() {
    this.up = this.coreService.getUserPrivilage();
    this.base_url = this.apiService.PHP_API_SERVER;

  }

  clearForm() {
    console.log('aa')
 //   this.btnReset.nativeElement.click();
    this.impRes = null;
  }


}
